import { Listbox, Transition } from "@headlessui/react";
import { Fragment } from "react";
import Select from "hardcover-ui/components/Select";
import Text from "hardcover-ui/components/Text";
import { SelectOptionThemeProps } from "hardcover-ui/theme/components/select";

type LanguageChanged = (newLanguage: string) => void;

const LanguageOption = ({ language }: { language: string }) => {
  return (
    <Text variant={language ? "normal" : "secondary"}>
      {language.toLocaleUpperCase()}
    </Text>
  );
};

const ListOptions = ({ codes }: { codes: string[] }) => (
  <Transition
    as={Fragment}
    leave="transition ease-in duration-100"
    leaveFrom="opacity-100"
    leaveTo="opacity-0"
  >
    <Select.Options>
      <Select.Option
        key="no-reading-format"
        value={null}
        className="font-semibold text-center"
      >
        All
      </Select.Option>
      {codes.map((code) => (
        <Select.Option key={code || "code-none"} value={code || ""}>
          <LanguageOption language={code} />
        </Select.Option>
      ))}
    </Select.Options>
  </Transition>
);

const ChooseLanguage = ({
  language,
  codes,
  onChange,
  size
}: {
  language: string;
  codes: string[];
  onChange: LanguageChanged;
  size: SelectOptionThemeProps["size"];
}) => (
  <div className="relative">
    <Listbox value={language} onChange={onChange}>
      {({ open }) => (
        <>
          <Select.Button open={open} size={size}>
            {language ? <LanguageOption language={language} /> : <>All</>}
          </Select.Button>
          <ListOptions codes={codes} />
        </>
      )}
    </Listbox>
  </div>
);

export const FilterLanguage = ({
  value,
  codes,
  onChange,
  size="sm"
}: {
  value?: string;
  codes: string[];
  onChange: LanguageChanged;
  size?: SelectOptionThemeProps["size"]
}) => {
  return <ChooseLanguage codes={codes} language={value} onChange={onChange} size={size} />;
};
